// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TimesheetYearlyEmployeeReport  {
    _originalTypeClassName = "Loom.BO.TimesheetYearlyEmployeeReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TimesheetYearlyEmployeeReport.translate = translateService;
}
this.Id = null;
this.TotalHoursInTimesheets = null;
this.MaxAnnualHours = null;
this.PercentageInTimesheets = null;
this.Year = null;
this.HoursInEUProjects = null;
this.HoursInOtherProjects = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TotalHoursInTimesheets:any;
MaxAnnualHours:any;
PercentageInTimesheets:any;
Year:any;
HoursInEUProjects:any;
HoursInOtherProjects:any;
Contract:any;
static setContract = ($this, value) => {
var oldValue = $this.Contract;
$this.Contract = value;
if (value != null) {
}
}

static GetPercentageInTimesheets($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.MaxAnnualHours, () => 0))) {return 0.0;}
return Joove.Common.safeNumber((Joove.Common.safeNumber(Domain.TimesheetYearlyEmployeeReport.GetTotalHoursInTimesheets($this)) / Joove.Common.safeNumber($this?.MaxAnnualHours))) * Joove.Common.safeNumber(100.0);
}
static GetTotalHoursInTimesheets($this: any): any{return Joove.Common.safeNumber($this?.HoursInEUProjects) + Joove.Common.safeNumber($this?.HoursInOtherProjects);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}